import { FixedGridItem } from '@/ui';
import { FooterLinkList } from './FooterLinkList';
import { IFooterLinkSection } from './types';

export function FooterLinkSection({ links }: IFooterLinkSection) {
	return (
		<FixedGridItem>
			<FooterLinkList links={links} />
		</FixedGridItem>
	);
}
